export const VIDEO_HOST = {
  VIMEO: 'Vimeo'
};
